
export const PASSWORD = {
  FORGOT_PASSWORD_DIALOG: "forgot-password-dialog",
};
